import React, { PureComponent } from 'react';
import { 
  Button,
  MobileStepper,
  withStyles 
} from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { withRouter } from 'react-router-dom';
import { withApollo,Mutation } from 'react-apollo';
import CompanyProfileStepOne from './CompanyProfileStepOne';
import CompanyProfileStepTwo from './CompanyProfileStepTwo';
import CompanyProfileStepThree from './CompanyProfileStepThree';
import CompletePage from './CompletePage';
import { CreateCompanyProfile } from '../../../queries/users';
import { connect } from 'react-redux';
import clsx from 'clsx';

const useStyles = (theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  nextButton: {
    float: 'right',
    background: '#5B9FAB',
    '&:hover': {
      background: '#5B9FAB',
      borderColor: '#5B9FAB',
      color: 'white'
    },
  },
  backButton: {
    border: '2px solid #5B9FAB',
    color: '#5B9FAB',
    '&:hover': {
      background: '#5B9FAB',
      borderColor: '#5B9FAB',
      color: 'white'
    },
  },
  mobileStepper:{
    background: "white",
    margin: "auto",
    width: "12%",
    dot:{
      width:'16px',
      height:'16px',
      color: '#5B9FAB',
    }
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '3%',
    padding: theme.spacing(2, 4, 3),
  },
  instructions: {
    color: '#5B9FAB',
  },
});

function getSteps() {
  return ['Step 1', 'Step 2', 'Step 3'];
}

function getStepContent(step,saveCompanyLocation,saveCompanyIndustry,saveCompanyYears,
  saveCompanyNumWorkers,saveCompanyAnnualRevenue,saveCompanyDescription,
  savecompanyProductDeliveryMethod,savecompanyEmployeesWorkType,saveCompanyDataCollected,
  saveCompanyDataRecordCount,saveCompanyDataStorage,saveCompanyDataAccessLevel,companyLocation,
  companyYears,companyNumWorkers,companyIndustry,companyRevenue, companyDescription, deliveryMethod,
  employeeWorkType,dataCollected,dataStorage,dataRecordCount, dataAccessLevel
  ){
  // eslint-disable-next-line default-case
  switch (step) {
    case 0:
      return <CompanyProfileStepOne 
                saveLocation={saveCompanyLocation} 
                saveIndustry={saveCompanyIndustry} 
                saveYears={saveCompanyYears} 
                saveWorkers={saveCompanyNumWorkers} 
                saveRevenue={saveCompanyAnnualRevenue}
                companyLocation={companyLocation}
                companyYears={companyYears}
                companyNumWorkers={companyNumWorkers}
                companyIndustry={companyIndustry}
                companyRevenue={companyRevenue}
              />;
    case 1:
      return <CompanyProfileStepTwo 
                saveDescription={saveCompanyDescription} 
                saveDeliveryMethod={savecompanyProductDeliveryMethod} 
                saveWorkType={savecompanyEmployeesWorkType}
                companyDescription={companyDescription}
                deliveryMethod={deliveryMethod}
                employeeWorkType={employeeWorkType}
              />;
    case 2:
      return <CompanyProfileStepThree 
                saveDataCollected={saveCompanyDataCollected} 
                saveRecordCount={saveCompanyDataRecordCount} 
                saveDataStorage={saveCompanyDataStorage} 
                saveAccessLevel={saveCompanyDataAccessLevel}
                dataCollected={dataCollected}
                dataStorage={dataStorage}
                dataRecordCount={dataRecordCount}
                dataAccessLevel={dataAccessLevel}
              />;
    case 3:
      return <CompletePage/>
  }
}


class CompanyProfile extends PureComponent {

  constructor (props) {
    super(props)
    this._isMounted = false;
    this.state = {
      activeStep: (props.prev !== null && props.prev.currentStep !== null && props.prev.currentStep !== undefined) ? parseInt(props.prev.currentStep) : 0,
      steps: getSteps(),
      // company profile data fields below

      //step 1
      companyLocation : (props.prev !== null && props.prev.address !== null && props.prev.address !==undefined) ? props.prev.address : "",
      companyIndustry : (props.prev !== null && props.prev.industry !== null && props.prev.industry !==undefined) ? props.prev.industry : "",
      companyYears : (props.prev !== null && props.prev.yearsInBusiness !== null && props.prev.yearsInBusiness !==undefined) ? props.prev.yearsInBusiness : "",
      companyAnnualRevenue : (props.prev !== null && props.prev.revenue !== null && props.prev.revenue !==undefined) ? props.prev.revenue : "",
      companyNumWorkers : (props.prev !== null && props.prev.numEmployees !== null && props.prev.numEmployees !==undefined) ? props.prev.numEmployees : "",
      step1SubmitAttempt: false,
      step1Filled: false,

      //step 2
      companyDescription: (props.prev !== null && props.prev.companyDescription !== null && props.prev.companyDescription !==undefined) ? props.prev.companyDescription : "",
      companyProductDeliveryMethod: (props.prev !== null && props.prev.productDeliveryOptions !== null && props.prev.productDeliveryOptions !==undefined) ? props.prev.productDeliveryOptions : "",
      companyEmployeesWorkType: (props.prev !== null && props.prev.employeeLocation !== null && props.prev.employeeLocation !==undefined) ? props.prev.employeeLocation : "",
      step2SubmitAttempt: false,
      step2Filled: false,

      //step 3
      companyDataCollected: (props.prev !== null && props.prev.dataCollected !== null && props.prev.dataCollected !==undefined) ? props.prev.dataCollectd : [],
      companyDataRecordCount: (props.prev !== null && props.prev.numRecordsProcessed !== null && props.prev.numRecordsProcessed !==undefined) ? props.prev.numRecordsProcessed : "",
      companyDataStorage: (props.prev !== null && props.prev.dataLocation !== null && props.prev.dataLocation !==undefined) ? props.prev.dataLocation: "",
      companyDataAccessLevel: (props.prev !== null && props.prev.thirdPartyAccess !== null && props.prev.thirdPartyAccess !==undefined) ? props.prev.thirdPartyAccess: "",
      step3SubmitAttempt: false,
      step3Filled: false

    };

    // Bind event handlers and methods
    this.handleBack = this._handleBack.bind(this)
    this.handleClick = this._handleClick.bind(this)

    this.saveCompanyIndustry = this._saveCompanyIndustry.bind(this)
    this.saveCompanyLocation = this._saveCompanyLocation.bind(this)
    this.saveCompanyYears = this._saveCompanyYears.bind(this)
    this.saveCompanyAnnualRevenue = this._saveCompanyAnnualRevenue.bind(this)
    this.saveCompanyNumWorkers = this._saveCompanyNumWorkers.bind(this)
    
    this.saveCompanyDescription = this._saveCompanyDescription.bind(this)
    this.savecompanyProductDeliveryMethod = this._savecompanyProductDeliveryMethod.bind(this)
    this.savecompanyEmployeesWorkType = this._savecompanyEmployeesWorkType.bind(this)

    this.saveCompanyDataCollected = this._saveCompanyDataCollected.bind(this)
    this.saveCompanyDataRecordCount = this._saveCompanyDataRecordCount.bind(this)
    this.saveCompanyDataStorage = this._saveCompanyDataStorage.bind(this)
    this.saveCompanyDataAccessLevel = this._saveCompanyDataAccessLevel.bind(this)
  }
  //Step 1 Save Functions
  _saveCompanyLocation(location){
    this.setState({companyLocation:location})
  }
  _saveCompanyIndustry(industry){
    this.setState({companyIndustry:industry})
  }
  _saveCompanyYears(years){
    this.setState({companyYears:years})
  }
  _saveCompanyAnnualRevenue(revenue){
    this.setState({companyAnnualRevenue:revenue})
  }
  _saveCompanyNumWorkers(numWorkers){
    this.setState({companyNumWorkers:numWorkers})
  }

  //Step 2 Save Functions
  _saveCompanyDescription(description){
    this.setState({companyDescription:description})
  }
  _savecompanyProductDeliveryMethod(deliveryMethod){
    this.setState({companyProductDeliveryMethod:deliveryMethod})
  }
  _savecompanyEmployeesWorkType(workType){
    this.setState({companyEmployeesWorkType:workType})
  }

  //Step 3 Save Functions
  _saveCompanyDataCollected(dataCollected){
    this.setState({companyDataCollected:dataCollected})
  }
  _saveCompanyDataRecordCount(recordCount){
    this.setState({companyDataRecordCount:recordCount})
  }
  _saveCompanyDataStorage(dataStorage){
    this.setState({companyDataStorage:dataStorage})
  }
  _saveCompanyDataAccessLevel(accessLevel){
    this.setState({companyDataAccessLevel:accessLevel})
  }

  //Stepper Navigation Functions

  _handleClick = (createCompanyProfile) => {
    if(this.state.activeStep === 0){
      if(
        this.state.companyLocation === "" ||
        this.state.companyIndustry === "" ||
        this.state.companyYears === "" ||
        this.state.companyAnnualRevenue === "" ||
        this.state.companyNumWorkers === ""
      ){
      }else{

        createCompanyProfile({
          variables: {
            tenantId: this.props.user["custom:tenant"],
            address: this.state.companyLocation,
            currentStep: this.state.activeStep,
            industry: this.state.companyIndustry,
            revenue: Number(this.state.companyAnnualRevenue),
            numEmployees: this.state.companyNumWorkers,
            yearsInBusiness: Number(this.state.companyYears),
            companyDescription: this.state.companyDescription,
            productDeliveryOptions: this.state.companyProductDeliveryMethod,
            employeeLocation: this.state.companyEmployeesWorkType,
            dataCollected: this.state.companyDataCollected,
            dataLocation: this.state.companyDataStorage,
            numRecordsProcessed: this.state.companyDataRecordCount,
            thirdPartyAccess: this.state.companyDataAccessLevel
          }
        })

        this.setState({step1Filled: true})
        this.setState({activeStep:this.state.activeStep +1})
      }
      this.setState({step1SubmitAttempt:true})
    }

    else if(this.state.activeStep === 1){
      if(
        this.state.companyDescription === "" ||
        this.state.companyProductDeliveryMethod === "" ||
        this.state.companyEmployeesWorkType === ""
      ){
      }else{

        createCompanyProfile({
          variables: {
            tenantId: this.props.user["custom:tenant"],
            address: this.state.companyLocation,
            currentStep: this.state.activeStep,
            industry: this.state.companyIndustry,
            revenue: Number(this.state.companyAnnualRevenue),
            numEmployees: this.state.companyNumWorkers,
            yearsInBusiness: Number(this.state.companyYears),
            companyDescription: this.state.companyDescription,
            productDeliveryOptions: this.state.companyProductDeliveryMethod,
            employeeLocation: this.state.companyEmployeesWorkType,
            dataCollected: this.state.companyDataCollected,
            dataLocation: this.state.companyDataStorage,
            numRecordsProcessed: this.state.companyDataRecordCount,
            thirdPartyAccess: this.state.companyDataAccessLevel
          }
        })

        this.setState({step2Filled: true})
        this.setState({activeStep:this.state.activeStep +1})
      }
      this.setState({step2SubmitAttempt:true})
    }

    else if(this.state.activeStep === 2){
      if(
        this.state.companyDataCollected.length === 0 ||
        this.state.companyDataRecordCount === "" ||
        this.state.companyDataStorage === "" ||
        this.state.companyDataAccessLevel === ""        
      ){  
      }else{

        createCompanyProfile({
          variables: {
            tenantId: this.props.user["custom:tenant"],
            address: this.state.companyLocation,
            currentStep: this.state.activeStep,
            industry: this.state.companyIndustry,
            revenue: Number(this.state.companyAnnualRevenue),
            numEmployees: this.state.companyNumWorkers,
            yearsInBusiness: Number(this.state.companyYears),
            companyDescription: this.state.companyDescription,
            productDeliveryOptions: this.state.companyProductDeliveryMethod,
            employeeLocation: this.state.companyEmployeesWorkType,
            dataCollected: this.state.companyDataCollected,
            dataLocation: this.state.companyDataStorage,
            numRecordsProcessed: this.state.companyDataRecordCount,
            thirdPartyAccess: this.state.companyDataAccessLevel
          }
        })

        this.setState({step3Filled: true})
        this.setState({activeStep:this.state.activeStep +1})        
      }
      this.setState({step3SubmitAttempt:true})
    }
  }

  _handleBack = () => {
    if(this.state.activeStep === 1){
      this.setState({step2Filled: false})
      this.setState({step2SubmitAttempt:false})
    }
    else if(this.state.activeStep === 2){
      this.setState({step3Filled: false})
      this.setState({step3SubmitAttempt:false})
    }
    this.setState({activeStep:this.state.activeStep -1})
  };


  render(){
    const { classes } = this.props;
    let validationError;

    if(!this.state.step1Filled && this.state.step1SubmitAttempt && this.state.activeStep===0){
      validationError = <div id="error_validation_message">All fields are required</div>
    }
    else if(!this.state.step2Filled && this.state.step2SubmitAttempt && this.state.activeStep===1){
      validationError = <div id="error_validation_message">All fields are required</div>
    }
    else if(!this.state.step3Filled && this.state.step3SubmitAttempt && this.state.activeStep===2){
      validationError = <div id="error_validation_message">All fields are required</div>
    }
    else{
      validationError = null
    }

    return (
      <div className={classes.paper}>
        <div id="modal_content">
            <div>
              <span className={classes.instructions}>{getStepContent(this.state.activeStep,
                this.saveCompanyLocation,this.saveCompanyIndustry,this.saveCompanyYears,
                this.saveCompanyNumWorkers,this.saveCompanyAnnualRevenue,this.saveCompanyDescription,
                this.savecompanyProductDeliveryMethod, this.savecompanyEmployeesWorkType,this.saveCompanyDataCollected,
                this.saveCompanyDataRecordCount,this.saveCompanyDataStorage,this.saveCompanyDataAccessLevel,this.state.companyLocation,
                this.state.companyYears,this.state.companyNumWorkers,this.state.companyIndustry,this.state.companyAnnualRevenue,
                this.state.companyDescription,this.state.companyProductDeliveryMethod,this.state.companyEmployeesWorkType,
                this.state.companyDataCollected,this.state.companyDataStorage,this.state.companyDataRecordCount,this.state.companyDataAccessLevel
                )}</span>
                          {validationError}
              <div>
                {this.state.activeStep > 2 ? null : 
                  <Button variant="outlined" disabled={this.state.activeStep === 0} onClick={this.handleBack} className={classes.backButton}>
                      Back
                  </Button>
                }
                  {this.state.activeStep > 2 ? null : <Mutation 
                          mutation={CreateCompanyProfile()}
                          onCompleted={() => {
                          }}>
                          {(createCompanyProfile) => (
                              <Button
                              variant="contained"
                              color="primary"
                              onClick={()=>{
                                this.handleClick(createCompanyProfile)
                                }
                              }
                              className={clsx(classes.nextButton,classes.button)}
                              >
                              {this.state.activeStep === this.state.steps.length - 1 ? `That's it!` : <React.Fragment>Next <KeyboardArrowRightIcon/></React.Fragment>}
                              </Button>
                          )}
                            </Mutation> }

                  { this.state.activeStep > 2 ? null : <MobileStepper
                      variant="dots"
                      steps={3}
                      position="static"
                      activeStep={this.state.activeStep}
                      className={classes.mobileStepper}
                  /> }
              </div>
            </div>
        </div>
      </div>
    )
  }

}

function mapStateToProps(state) {
  return {
      user: state.auth.user,
      settings: state.auth.settings
  }
}

export default connect(mapStateToProps)(withRouter(withApollo((withStyles(useStyles)(CompanyProfile)))))




// WEBPACK FOOTER //
// ./src/components/onboarding/components/CompanyProfile.js